import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const SecondaryProcessRow = ({ children, justifyContent = 'flex-start' }) => (
    <Box
        sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: justifyContent,
            width: '100%',
        }}
    >
        {children}
    </Box>
)

SecondaryProcessRow.propTypes = {
    children: PropTypes.node,
    justifyContent: PropTypes.string,
}

export default SecondaryProcessRow
